import { SOURCE_PLATFORM_TYPE } from '@/entities/public-filter';

/**
 * Generates a TikTok profile URL from a username
 * @param username - The TikTok username (with or without @)
 * @returns The full TikTok profile URL
 */
export function getTikTokProfileUrl(username: string): string {
  // Remove @ if present at the beginning
  const cleanUsername = username.startsWith('@') ? username.slice(1) : username;
  return `https://www.tiktok.com/@${cleanUsername}`;
}

export function getInstagramProfileUrl(username: string): string {
  const cleanUsername = username.startsWith('@') ? username.slice(1) : username;
  return `https://www.instagram.com/${cleanUsername}`;
}

export function getYoutubeProfileUrl(username: string): string {
  const cleanUsername = username.startsWith('@') ? username.slice(1) : username;
  return `https://www.youtube.com/@${cleanUsername}`;
}

export function getProfileUrl(username: string, platform: SOURCE_PLATFORM_TYPE): string {
  switch (platform) {
    case SOURCE_PLATFORM_TYPE.TIKTOK:
      return getTikTokProfileUrl(username);
    case SOURCE_PLATFORM_TYPE.INSTAGRAM:
      return getInstagramProfileUrl(username);
    case SOURCE_PLATFORM_TYPE.YOUTUBE:
      return getYoutubeProfileUrl(username);
  }
}
